"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[31266],{

/***/ 31266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Detail_Right; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/Ribbon.js


var Ribbon = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "px-3 py-2 font-bold text-xxs border border-[#EEA4BB] rounded-[3px] shadow-ribbon1 bg-detail-border-color",
        children: children
    });
};
/* harmony default export */ var components_Ribbon = (Ribbon);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./components/Detail/FloorPlan.js





var FloorPlan = function() {
    var TabItem = function(param) {
        var children = param.children, isActive = param.isActive;
        return /*#__PURE__*/ _jsx("div", {
            className: "px-4 pt-3 pb-5 lg:p-0 text-white  lg:bg-primary lg:text-white lg:mr-12 whitespace-nowrap " + (isActive ? "bg-white text-primary" : ""),
            children: children
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full lg:mt-5  " + styles.bg,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "overflow-x-auto flex-nowrap flex font-bold text-15 tracking-11 lg:leading-[40px] bg-primary lg:rounded-tl-lg lg:rounded-tr-lg px-2 sm:px-[1.3rem] lg:px-9 pt-20 lg:py-5 -mt-11 lg:mt-0",
                children: [
                    /*#__PURE__*/ _jsx(TabItem, {
                        isActive: "1",
                        children: "ZEMIN KAT"
                    }),
                    /*#__PURE__*/ _jsx(TabItem, {
                        children: "KAT 1"
                    }),
                    /*#__PURE__*/ _jsx(TabItem, {
                        children: "KAT 2"
                    }),
                    /*#__PURE__*/ _jsx(TabItem, {
                        children: "KAT 3"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex px-3 lg:pl-8 lg:pr-9 lg:pt-10 flex-col lg:flex-row lg:bg-white lg:bg-transparent before:content-[''] before:h-[189px] before:absolute before:bg-white before:w-full before:left-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.mobileShadow,
                        children: /*#__PURE__*/ _jsxs("ul", {
                            className: styles.tabs,
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    children: "Salon"
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "Teras"
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: styles.active,
                                    children: "Yatak Odas\u0131 1"
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "Yatak Odas\u0131 2"
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "Bah\xe7e"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "lg:w-8/12",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "relative h-60",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        alt: "TEst",
                                        className: "rounded-md",
                                        src: "villavillam_villa_disney_duo_kiralama-24_1200x800_451.jpg",
                                        objectFit: "cover",
                                        layout: "fill",
                                        placeholder: "blur",
                                        blurDataURL: "https://cdn.villavillam.com.tr/uploads/50/villavillam_villa_disney_duo_kiralama-24_1200x800_451.jpg",
                                        loader: Remote
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("ul", {
                                    className: "mt-4 lg:mt-8 ml-6 lg:ml-3 list-disc text-[#0A97B9] flex flex-wrap",
                                    children: [
                                        /*#__PURE__*/ _jsx("li", {
                                            className: "text-sm w-1/2 mt-3",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "text-black",
                                                children: "\xc7ift Ki\u015Filik Yatak"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            className: "text-sm w-1/2 mt-3",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "text-black",
                                                children: "Banyo \xc7ift Ki\u015Filik Yatak"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            className: "text-sm w-1/2 mt-3",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "text-black",
                                                children: "Jakuzi"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            className: "text-sm w-1/2 mt-3",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "text-black",
                                                children: "Jakuzi,Klima"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            className: "text-sm w-1/2 mt-3",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "text-black",
                                                children: "Klima"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            className: "text-sm w-1/2 mt-3",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "text-black",
                                                children: "TV"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Detail_FloorPlan = ((/* unused pure expression or super */ null && (FloorPlan)));

// EXTERNAL MODULE: ./components/Detail/Icons.js
var Icons = __webpack_require__(80103);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Detail/IncludedPrice.js





var IncludedPrice = function(props) {
    var ref = (0,TranslationContext/* useTranslation */.m)(), inludedPrice = ref.inludedPrice, notIncludedPrice = ref.notIncludedPrice;
    var data = [
        {
            title: inludedPrice,
            items: props.data[0]
        },
        {
            title: notIncludedPrice,
            items: props.data[1]
        }, 
    ];
    var ref1 = (0,react.useState)(0), active = ref1[0], setActive = ref1[1];
    var Item = function(param) {
        var text = param.text;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            className: "flex content-center items-center mb-5 w-1/2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "iconsImgFilter",
                    children:  false ? /*#__PURE__*/ 0 : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                        name: "DetailIncludedPrice"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-bold text-sm ml-3 text-brand-gray-2",
                    children: text
                })
            ]
        });
    };
    var ListItem = function(param) {
        var items = param.items, active = param.active;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: active ? "flex flex-wrap" : "hidden",
            children: items && items.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    text: item
                }, i);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-6 lg:mt-11 w-full lg:px-4 xl:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-between font-bold text-sm mb-7",
                children: data && data.map(function(tab, i) {
                    return tab.items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function(event) {
                            return setActive(i);
                        },
                        className: active === i ? "active opacity-100" : "opacity-30",
                        children: tab.title
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                active: true,
                items: data[active].items
            })
        ]
    });
};
/* harmony default export */ var Detail_IncludedPrice = (IncludedPrice);

;// CONCATENATED MODULE: ./components/Detail/Pool.js




var Pool = function(param) {
    var title = param.title, boy = param.boy, genislik = param.genislik, derinlik = param.derinlik;
    var ref = (0,TranslationContext/* useTranslation */.m)(), poolLength = ref.poolLength, poolWidth = ref.poolWidth, poolDepth = ref.poolDepth;
    if (boy) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-wrap bg-DetailVideoBg lg:pt-10 lg:pb-9 py-6 px-5 md:pl-7 lg:pl-8 rounded-lg text-white md:w-1/3 bg-red-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "flex items-start xl:items-center text-base xl:mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                            name: "DetailPool"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "-mt-1.5 xl:mt-0",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex lg:flex-col xl:flex-col w-full gap-x-8 pl-12 ml-1 xl:ml-0 xl:pl-0 -mt-6 xl:mt-0 flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "xl:w-1/2 mt-2 opacity-50 mr-2 xl:mr-0",
                                children: poolLength
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "xl:w-1/2 mt-2 ml-auto",
                                children: boy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "xl:w-1/2 mt-2 opacity-50 mr-2 xl:mr-0",
                                children: poolWidth
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "xl:w-1/2 mt-2 ml-auto",
                                children: genislik
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "xl:w-1/2 mt-2 opacity-50 mr-2 xl:mr-0",
                                children: poolDepth
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "xl:w-1/2 mt-2 ml-auto",
                                children: derinlik
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Detail_Pool = (Pool);

;// CONCATENATED MODULE: ./components/Detail/Wrapper.js


var Wrapper = function(param) {
    var children = param.children, classname = param.classname;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classname,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-containerWidth max-w-full mx-auto lg:px-2 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex max-w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:w-72 xl:w-[374px] lg:mr-4 flex-shrink-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[calc(100%-396px)] flex-auto",
                            children: children
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Detail_Wrapper = (Wrapper);

// EXTERNAL MODULE: ./components/KiralaGelBanner.js
var KiralaGelBanner = __webpack_require__(14082);
;// CONCATENATED MODULE: ./components/Detail/Right.js











var Fancybox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 99965).then(__webpack_require__.bind(__webpack_require__, 92235));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92235)
            ];
        }
    }
});
var Faq = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 41458).then(__webpack_require__.bind(__webpack_require__, 82814));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82814)
            ];
        }
    },
    ssr: false
});
var CheckIn = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 52643).then(__webpack_require__.bind(__webpack_require__, 52643));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52643)
            ];
        }
    },
    ssr: false
});
var Description = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 33569).then(__webpack_require__.bind(__webpack_require__, 33569));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33569)
            ];
        }
    }
});
var Distance = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 21096).then(__webpack_require__.bind(__webpack_require__, 21096));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21096)
            ];
        }
    },
    ssr: false
});
var HeaderCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 31076).then(__webpack_require__.bind(__webpack_require__, 31076));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31076)
            ];
        }
    }
});
var SonDakika = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1135).then(__webpack_require__.bind(__webpack_require__, 1135));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1135)
            ];
        }
    }
});
var Prices = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 42061).then(__webpack_require__.bind(__webpack_require__, 42061));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42061)
            ];
        }
    }
});
var Properties = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 99788).then(__webpack_require__.bind(__webpack_require__, 99788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99788)
            ];
        }
    },
    ssr: false
});
var Right = function(param) {
    var showAvailability = param.showAvailability, setShowAvailability = param.setShowAvailability, page = param.page, isPhone = param.isPhone, deviceType = param.deviceType, onSelectSonDakika = param.onSelectSonDakika;
    var ref = (0,TranslationContext/* useTranslation */.m)(), faqVideoTitle = ref.faqVideoTitle, poolDimensions = ref.poolDimensions, childPool = ref.childPool, indoorPool = ref.indoorPool, reviewCtaTitle = ref.reviewCtaTitle, reviewCtaThisVilla = ref.reviewCtaThisVilla, reviewCtaText = ref.reviewCtaText, googleWriteReview = ref.googleWriteReview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden w-full ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Detail_Wrapper, {
                classname: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderCard, {
                        page: page
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SonDakika, {
                        page: page,
                        onSelect: onSelectSonDakika
                    }),
                    page.onecikan ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Properties, {
                        onecikan: page.onecikan
                    }) : null,
                    page.gavel == "0" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-col xl:flex-row bg-white lg:border-[3px] border-detail-border-color rounded lg:pt-9 lg:pb-8 lg:pl-9 lg:pr-8 px-3 sm:px-[1.3rem] pt-3",
                        children: [
                            page.ribbon || page.ribbon2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col ml:flex-row text-center gap-3 mt-1 pb-3 justify-center lg:hidden",
                                children: [
                                    page.ribbon && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Ribbon, {
                                        children: page.ribbon
                                    }),
                                    page.ribbon2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Ribbon, {
                                        children: page.ribbon2
                                    })
                                ]
                            }) : "",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Prices, {
                                showAvailability: showAvailability,
                                setShowAvailability: setShowAvailability,
                                ProductId: page.id,
                                start2: page.start2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "xl:w-[340px] lg:w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fancybox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative cursor-pointer rounded-md overflow-hidden hidden lg:block",
                                            "data-fancybox": "video-gallery1",
                                            "data-src": "https://www.youtube.com/watch?v=E7eHfwLydYY",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "bg-DetailVideoBg w-full h-56"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "absolute top-2/4 left-2/4 flex flex-col items-center w-full lg:w-auto transform -translate-x-2/4 -translate-y-2/4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                                            name: "PlayButtonBig",
                                                            size: 41
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-bold text-white text-sm mt-1.5",
                                                            children: faqVideoTitle
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_IncludedPrice, {
                                        data: [
                                            page.fiyata_dahil,
                                            page.fiyata_dahil_olmayanlar
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIn, {
                        page: page
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KiralaGelBanner/* default */.Z, {
                            src: "/images/kiralagel-banner/575x260.png",
                            listingPage: true,
                            heightClass: "h-52",
                            deviceType: deviceType
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        title: page.title2,
                        icerik: page.icerik
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex -mt-20 relative items-start flex-col xl:flex-row bg-[#EFF5F7] lg:bg-transparent",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex flex-col gap-y-3 xl:w-[274px] flex-shrink-0 px-5 sm:px-[1.3rem] lg:px-0 order-1 xl:order-2 relative ml-0.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full flex gap-x-3 px-5 sm:px-[1.3rem] lg:px-0 relative flex-col gap-y-2 md:flex-row",
                                children: [
                                    page.yuzme_havuzu != "Yok" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_Pool, {
                                        title: poolDimensions,
                                        boy: page.yuzme_havuzu_uzunluk,
                                        genislik: page.yuzme_havuzu_genislik,
                                        derinlik: page.yuzme_havuzu_derinlik
                                    }),
                                    page.cocuk_havuzu && page.cocuk_havuzu != "Yok" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_Pool, {
                                        title: childPool,
                                        boy: page.cocuk_havuzu_uzunluk,
                                        genislik: page.cocuk_havuzu_genislik,
                                        derinlik: page.cocuk_havuzu_derinlik
                                    }),
                                    page.kapali_havuz && page.kapali_havuz != "Yok" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_Pool, {
                                        title: indoorPool,
                                        boy: page.kapali_havuz_uzunluk,
                                        genislik: page.kapali_havuz_genislik,
                                        derinlik: page.kapali_havuz_derinlik
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Distance, {
                        id: page.id,
                        harita: page.harita,
                        enlem: page.enlem,
                        boylam: page.boylam,
                        baslik: page.baslik
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Detail_Wrapper, {
                classname: "relative sm:mt-56 bg-[#EFF5F7] sm:bg-transparent",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq, {
                        data: page.faq
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full mt-8 pb-12 px-3 sm:px-[1.3rem] lg:px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bg-teklif-gra rounded-md p-8 lg:p-10 flex flex-col md:flex-row items-center justify-between gap-6 lg:gap-10 shadow-md relative overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "absolute -left-12 -top-12 opacity-10 pointer-events-none z-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "w-72 h-72",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            transform: "matrix(1, 0, 0, 1, 27.009001, -39.238998)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.225 -9.424 56.474 -10.686 57.324 L -10.686 60.325 L -6.842 60.325 C -4.608 58.235 -3.264 55.159 -3.264 51.509 Z",
                                                    fill: "#ffffff"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M -14.754 63.239 C -11.516 63.239 -8.801 62.157 -6.821 60.324 L -10.685 57.323 C -11.761 58.044 -13.138 58.469 -14.754 58.469 C -17.869 58.469 -20.518 56.364 -21.464 53.535 L -25.276 53.535 L -25.276 56.453 C -23.414 60.188 -19.542 63.239 -14.754 63.239 Z",
                                                    fill: "#ffffff"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M -21.464 53.535 C -21.711 52.801 -21.838 52.016 -21.838 51.213 C -21.838 50.407 -21.711 49.623 -21.464 48.889 L -21.464 45.971 L -25.276 45.971 C -26.046 47.508 -26.488 49.225 -26.488 51.213 C -26.488 53.197 -26.046 54.918 -25.276 56.453 L -21.464 53.535 Z",
                                                    fill: "#ffffff"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M -14.754 43.955 C -12.983 43.955 -11.396 44.57 -10.146 45.749 L -6.741 42.34 C -8.802 40.418 -11.516 39.239 -14.754 39.239 C -19.542 39.239 -23.414 42.29 -25.276 46.025 L -21.464 48.943 C -20.518 46.113 -17.869 43.955 -14.754 43.955 Z",
                                                    fill: "#ffffff"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-6 text-center md:text-left z-10 relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden md:flex bg-white p-4 shadow-sm flex-shrink-0 rounded-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                viewBox: "0 0 24 24",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "w-10 h-10",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    transform: "matrix(1, 0, 0, 1, 27.009001, -39.238998)",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.225 -9.424 56.474 -10.686 57.324 L -10.686 60.325 L -6.842 60.325 C -4.608 58.235 -3.264 55.159 -3.264 51.509 Z",
                                                            fill: "#4285F4"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M -14.754 63.239 C -11.516 63.239 -8.801 62.157 -6.821 60.324 L -10.685 57.323 C -11.761 58.044 -13.138 58.469 -14.754 58.469 C -17.869 58.469 -20.518 56.364 -21.464 53.535 L -25.276 53.535 L -25.276 56.453 C -23.414 60.188 -19.542 63.239 -14.754 63.239 Z",
                                                            fill: "#34A853"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M -21.464 53.535 C -21.711 52.801 -21.838 52.016 -21.838 51.213 C -21.838 50.407 -21.711 49.623 -21.464 48.889 L -21.464 45.971 L -25.276 45.971 C -26.046 47.508 -26.488 49.225 -26.488 51.213 C -26.488 53.197 -26.046 54.918 -25.276 56.453 L -21.464 53.535 Z",
                                                            fill: "#FBBC05"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M -14.754 43.955 C -12.983 43.955 -11.396 44.57 -10.146 45.749 L -6.741 42.34 C -8.802 40.418 -11.516 39.239 -14.754 39.239 C -19.542 39.239 -23.414 42.29 -25.276 46.025 L -21.464 48.943 C -20.518 46.113 -17.869 43.955 -14.754 43.955 Z",
                                                            fill: "#EA4335"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "pr-0 md:pr-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "text-2xl lg:text-3xl font-bold text-white mb-2 drop-shadow-sm",
                                                    children: reviewCtaTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-white opacity-95 text-sm lg:text-base leading-relaxed max-w-2xl",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            className: "font-bold",
                                                            children: page.baslik || reviewCtaThisVilla
                                                        }),
                                                        " ",
                                                        reviewCtaText
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://g.page/r/Cc84qp7cJY5HEBM/review",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "bg-white hover:bg-gray-100 text-primary font-bold text-sm lg:text-base px-8 py-4 w-full md:w-auto text-center transition-colors whitespace-nowrap shadow-md flex-shrink-0 z-10 rounded",
                                    children: googleWriteReview
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Detail_Right = (Right);


/***/ })

}]);